module.exports = __webpack_public_path__ + "img/user-1.d07d42a7.jpg";